<ng-select
  [items]="items()"
  [bindLabel]="label()"
  [bindValue]="value()"
  [typeahead]="searchSubject"
  (search)="handleSearch($event)"
  (close)="closed.emit()"
  (clear)="cleared.emit()"
  (change)="selected.emit($event)"
  [dropdownPosition]="dropdownPosition()"
  [loading]="isLoading()"
  [placeholder]="placeholder()"></ng-select>
